export const createHtml = (htmlString) => {
  let temp = document.createElement('template')
  htmlString = htmlString.trim()
  temp.innerHTML = htmlString
  return temp.content.firstChild
}

export const equalSizeElements = (elements) => {
  if (elements.length > 1) {
    let biggest = 0

    elements.forEach(el => {
      biggest = el.scrollHeight > biggest ? el.scrollHeight : biggest
    })

    elements.forEach(el => {
      el.style.height = `${biggest}px`
      el.classList.add('calculated')
    })

    const clearCalculatedClasses = () => {
      elements.forEach(el => {
        el.classList.remove('calculated')
        el.style.height = null
      })
      window.removeEventListener('resize', clearCalculatedClasses)
    }

    window.addEventListener('resize', clearCalculatedClasses)
  }
}